import React from 'react';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

const FootprintsSection = ({ footprintImage }) => {
  return (
    <section
      className="relative bg-cover bg-center py-16 px-6 md:px-20 text-white"
      style={{ backgroundImage: `url(${footprintImage})` }}
    >
      <div className="absolute inset-0 bg-[#2584C6]/80"></div>

      <div className="relative z-10">
        <h1 className="text-3xl md:text-4xl font-bold mb-4 text-center" data-aos="zoom-in">
          Our Footprints
        </h1>
        <p className="max-w-3xl text-lg mb-12 text-center mx-auto" data-aos="fade-up">
          Building impact through trusted partnerships, innovation, and technology across regions and industries.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <StatsCard
            value={100}
            suffix="+"
            label="Satisfied Customers"
            description="Trusted by startups, enterprises, and government organizations nationwide."
            delay={100}
          />
          <StatsCard
            value={5}
            suffix="+"
            label="Industry Verticals"
            description="Delivering tailored technology solutions for healthcare, finance, manufacturing, retail, education, and more."
            delay={200}
          />
          <StatsCard
            value={200}
            suffix="+"
            label="Projects Delivered"
            description="Successfully deployed intelligent, scalable, and secure solutions across industries and use cases."
            delay={300}
          />
        </div>
      </div>
    </section>
  );
};

const StatsCard = ({ value, suffix, label, description, delay }) => (
  <div className="p-6 text-center" data-aos="zoom-in" data-aos-delay={delay}>
    <p className="text-4xl font-bold">
      <CountUp start={0} end={value} duration={4} redraw={true} suffix={suffix}>
        {({ countUpRef, start }) => (
          <VisibilitySensor onChange={start} delayedCall>
            <span ref={countUpRef} />
          </VisibilitySensor>
        )}
      </CountUp>
    </p>
    <p className="text-xl mt-2">{label}</p>
    <p className="mt-3 text-sm">{description}</p>
  </div>
);

export default FootprintsSection;
